import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, inject, Input} from '@angular/core';
import {LocalizeTextPipe} from "@shared/pipes/localize-text/localize-text.pipe";
import {AppAuthService} from "@services/core/auth/app-auth.service";
import {hasValue} from "@shared/utils/helpers";
import {UserOnboardingService} from '@app/areas/account/onboarding/services/user-onboarding.service';
import {
  buildOnboardingFlowVm,
  OnboardingFlowVm,
} from '@app/areas/account/onboarding/utils/onboarding-progress-vm';

@Component({
  selector: 'app-my-onboarding-progress',
  standalone: true,
  imports: [CommonModule, LocalizeTextPipe],
  templateUrl: './my-onboarding-progress.component.html',
  styleUrls: ['./my-onboarding-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyOnboardingProgressComponent {
  readonly auth = inject(AppAuthService);
  private readonly onboarding = inject(UserOnboardingService);

  readonly vm = computed<OnboardingFlowVm | null>(() =>
    buildOnboardingFlowVm(this.onboarding.currentFlow$()),
  );

  readonly userProfile = computed(() => this.auth.user$()?.userProfile ?? null);

  readonly username$ = computed(() => {
    const identity = this.auth.user$()?.identityProfile ?? null;
    const appleId = identity?.appleLoginId;
    const username = identity?.username ?? '';

    if (hasValue(appleId)) {
      return 'Apple Login';
    }

    return username;
  });

  @Input()
  set progress(_: unknown) {
    // kept for template compatibility while the component reads the dedicated status service
  }
}
